export default __webpack_public_path__ + "static/media/small-mod2.7d6f0c39.png";